// Helper functions for detail views

export const calculateAge = (dateOfBirth) => {
  if (!dateOfBirth) return 'N/A';
  const birthDate = new Date(dateOfBirth);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age + ' year' + (age !== 1 ? 's' : '');
};

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const d = new Date(dateString);
  return `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')}`;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return 'NA';
  const d = new Date(dateString);
  const dateStr = `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')}`;
  const hour12 = (d.getHours() % 12 || 12).toString().padStart(2,'0');
  const ampm = d.getHours() >= 12 ? 'PM' : 'AM';
  const timeStr = `${hour12}:${d.getMinutes().toString().padStart(2,'0')} ${ampm}`;
  return `${dateStr} ${timeStr}`;
};

export const statusColors = {
  Upcoming: "bg-[#FEF7E7] text-[#FFA726] border-[#FFA726]",
  Completed: "bg-green-100 text-green-800 border-green-300",
  confirmed: "bg-green-100 text-green-800 border-green-300",
  cancelled: "bg-red-100 text-red-800 border-red-300",
  rescheduled: "bg-purple-100 text-purple-800 border-purple-300",
  Active: "bg-green-100 text-green-800 border-green-300",
  active: "bg-green-100 text-green-800 border-green-300",
  Inactive: "bg-red-100 text-red-800 border-red-300",
  inactive: "bg-red-100 text-red-800 border-red-300",
  verified: "bg-green-100 text-green-800 border-green-300",
  resolved: "bg-gray-200 text-gray-700 border-gray-300",
  Pending: "bg-yellow-100 text-yellow-600 border-yellow-300",
  pending: "bg-yellow-100 text-yellow-600 border-yellow-300",
  failed: "bg-red-100 text-red-600 border-red-300",
  draft: "bg-yellow-100 text-yellow-600 border-yellow-300",
  published: "bg-green-100 text-green-800 border-green-300",
  archived: "bg-red-100 text-red-800 border-red-300",
  Default: "bg-gray-100 text-gray-600 border-gray-300",
};
